'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _step = require('./step.c');

var _step2 = _interopRequireDefault(_step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
        var _ret;

        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.stepStates = {
            INTERACTIVE: 'interactive',
            PASSED: 'passed',
            FUTURE: 'future',
            HIDDEN: 'hidden'
        };


        var step = props.defaultStep || props.step;

        if (!step && props.children && props.children.length) {
            var list = _react2.default.Children.toArray(props.children);

            step = list.find(function (child) {
                return child && !!child.props.id;
            });
            step = step && step.props.id || null;
        }

        _this.state = {
            step: step
        };

        _this.crefs = {};

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(this);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.children) {
                var list = _react2.default.Children.toArray(nextProps.children),
                    currentStep = void 0;

                currentStep = list.find(function (child) {
                    return _this2.state.step === (child && child.props.id);
                });

                if (!currentStep) {
                    var nextStep = list.find(function (child) {
                        return !!child.props.id;
                    });

                    if (nextStep) {
                        this.setState({ step: nextStep.props.id });
                    }
                }

                if (nextProps.step && this.state.step !== nextProps.step) {
                    var _nextStep = list.find(function (child) {
                        return (child && child.props.id) === nextProps.step;
                    });

                    if (_nextStep) {
                        this.setState({ step: _nextStep.props.id });
                    }
                }
            }

            return this;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.children) {
                if (process && process.env.NODE_ENV !== 'production') {
                    console.error('Creating StepController without steps in component ' + this.displayName);
                }
            }

            var state = this._isPassedStepsHidden() ? this.stepStates.HIDDEN : this.stepStates.PASSED;

            return _react2.default.Children.map(this.props.children, function (child) {
                if (!child) {
                    return null;
                }

                if (!child.props.id) {
                    if (process && process.env.NODE_ENV !== 'production') {
                        console.error('Step must contain "id" prop. ' + _this3.displayName);
                    }

                    return null;
                }

                if (child.props.id === _this3.state.step) {
                    state = _this3.stepStates.INTERACTIVE;
                } else if (state === _this3.stepStates.INTERACTIVE) {
                    state = _this3.stepStates.FUTURE;
                }

                return _react2.default.createElement(_step2.default, {
                    state: state,
                    toNextStep: _this3.toNextStep.bind(_this3),
                    toPrevStep: _this3.toPrevStep.bind(_this3),
                    toStep: _this3.toStep.bind(_this3),
                    getModel: _this3.getModel.bind(_this3),
                    getActiveStep: _this3.getActiveStep.bind(_this3),
                    stepRefProvider: _this3._stepRef.bind(_this3),
                    key: child.props.id
                }, child);
            });
        }
    }, {
        key: 'toStep',
        value: function toStep(id) {
            var _this4 = this;

            if (id && this.props.children && this.props.children.length) {
                var list = _react2.default.Children.toArray(this.props.children),
                    nextStep = list.find(function (child) {
                    return (child && child.props.id) === id;
                });

                if (nextStep) {
                    return new Promise(function (resolve) {
                        _this4.setState({ step: id }, function () {
                            return resolve();
                        });
                    });
                } else {
                    Promise.reject('StepController call .toStep without children or invalid step ID');
                }
            } else {
                return Promise.reject('StepController call .toStep without children or invalid step ID');
            }
        }
    }, {
        key: 'getStep',
        value: function getStep(id) {
            return this.crefs[id] || null;
        }
    }, {
        key: 'getModel',
        value: function getModel(id) {
            var result = null;

            if (this.crefs[id] && typeof this.crefs[id].getModel === 'function') {
                result = this.crefs[id].getModel();
            }

            return result;
        }
    }, {
        key: 'getActiveStep',
        value: function getActiveStep() {
            return this.crefs[this.state.step] || null;
        }
    }, {
        key: 'toNextStep',
        value: function toNextStep() {
            var _this5 = this;

            if (this.state.step && this.props.children && this.props.children.length) {
                var list = _react2.default.Children.toArray(this.props.children),
                    current = void 0,
                    currentIndex = void 0,
                    rest = void 0,
                    nextStep = void 0;

                current = list.find(function (child) {
                    return _this5.state.step === (child && child.props.id);
                });
                currentIndex = list.indexOf(current);
                rest = list.slice(currentIndex + 1);
                nextStep = rest.find(function (child) {
                    return child && !!child.props.id;
                });

                if (nextStep) {
                    return this.toStep(nextStep.props.id);
                }
            }

            return Promise.resolve();
        }
    }, {
        key: 'toPrevStep',
        value: function toPrevStep() {
            var _this6 = this;

            if (this.state.step && this.props.children && this.props.children.length) {
                var list = _react2.default.Children.toArray(this.props.children),
                    current = void 0,
                    currentIndex = void 0,
                    prev = void 0,
                    prevStep = void 0;

                current = list.find(function (child) {
                    return _this6.state.step === (child && child.props.id);
                });
                currentIndex = list.indexOf(current);
                prev = list.slice(0, currentIndex).reverse();
                prevStep = prev.find(function (child) {
                    return child && !!child.props.id;
                });

                if (prevStep) {
                    return this.toStep(prevStep.props.id);
                }
            }

            return Promise.resolve();
        }
    }, {
        key: '_stepRef',
        value: function _stepRef(el) {
            if (el !== null && el.props.id) {
                this.crefs[el.props.id] = el;
            }
        }
    }, {
        key: '_isPassedStepsHidden',
        value: function _isPassedStepsHidden() {
            if (typeof this.props.hidePassedSteps === 'function') {
                return this.props.hidePassedSteps(this.state.step);
            } else {
                return this.props.hidePassedSteps;
            }
        }
    }]);

    return _class;
}(_react2.default.Component);

_class.defaultProps = {
    hidePassedSteps: false
};
_class.propTypes = {
    elementRef: _propTypes2.default.func,
    step: _propTypes2.default.string,
    defaultStep: _propTypes2.default.string,
    hidePassedSteps: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array])
};
_class.displayName = 'Base.Views.StepController';
exports.default = _class;